export default __webpack_public_path__ + "static/media/archivarIconosbarra-01.0db53b4b.png";